import { CapitalizeFirstLowercaseRest } from "../../../Helpers/CustomConverter";
import useGetProductIndexWithMask from "../../../Components/BasketPage/Hooks/useGetProductIndexWithMask";
import useGetSuppliers from "../../Shop/Hooks/useGetSuppliers";
import { useConfig } from "../../../Providers/ConfigProvider";
import { useAuth } from "../../../Providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useParams } from "../../../Providers/ParamsProvider";
import { getIndeksHeader } from "../../../Helpers/ValidatorHelper.jsx";

const ProductDetailsHeader = ({ product }) => {
    const navigate = useNavigate()
    const { authState } = useAuth()
    const { dataUrl } = useConfig()
    const { suppliers } = useGetSuppliers()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const { license, isMobile } = useParams()

    const generateLogo = () => {
        let supplier = suppliers.find(s => s.supplierId == product.supplierId)
        return <div className="row">
            {!supplier || !supplier.url || supplier.url.trim() == '' ?
                (<div className="col-12 d-flex align-items-center justify-content-start">
                    <span>{product.producent}</span>
                </div>)
                :
                (<div className="col-6 d-flex align-items-center justify-content-start">
                    <img src={`${dataUrl}/dostawcy/${supplier.url}.svg`} className="img-fluid" alt={product.producent} />
                </div>)}
        </div>
    }

    const buttonOfferStyle = authState.custId && authState.user && !authState.user.isOperator ? '' : 'collapse'
    const mainContainerPositionStyle = isMobile ? null : { width: '100%', height: '100%' }

    return (
        <div className="main-container-holder ps-3 pe-3" style={mainContainerPositionStyle}>
            <h4>{CapitalizeFirstLowercaseRest(product.title)}</h4>
            <span className="secondary-color-text mt-3">{CapitalizeFirstLowercaseRest(product.label)}</span>
            <div className="row">
                <div className="col-9 d-flex flex-column">
                    <span className="secondary-color-text">{getIndeksHeader(license)}: {getProductIndexWithMask(product.index)}</span>
                    <span className="secondary-color-text">Indeks producenta: {product.producentArtNo}</span>
                    <span className="secondary-color-text">Kod kreskowy: {product.ean}</span>
                </div>
                {generateLogo()}
            </div>
            <DimensionSection
                dimension={product.dimension}
            />
            <div className="d-flex justify-content-center mt-5 ">
                <button className={`btn-app-secondary ${buttonOfferStyle}`} onClick={() => { navigate('/OfferRequest/0/false/null', { state: { product } }) }}>Złóż zapytanie ofertowe</button>
            </div>
        </div>
    )
}

const DimensionSection = ({ dimension }) => {
    if (!dimension || (dimension.height == 0 && dimension.width == 0 && dimension.length == 0 && dimension.weightGross == 0)) { //gdy nieuzupełnione to nie wyświetlamy
        return null
    }
    return (<>
        <div className="row mt-2">
            <div className="col-3">
                <span>Wymiary: </span>
            </div>
            <div className="col">
                {dimension && (
                    <span className="ms-1" style={{ fontWeight: 'bold' }}>{`${dimension.length} cm / ${dimension.width} cm / ${dimension.height} cm`}</span>
                )}
            </div>
        </div>
        <div className="row">
            <div className="col-3">
                <span> Waga: </span>
            </div>
            <div className="col">
                <span className="ms-1" style={{ fontWeight: 'bold' }}>{`${dimension.weightGross} kg`}</span>
            </div>
        </div>
    </>)
}

export default ProductDetailsHeader